/** 期权相关接口 */
import Vue from 'vue'

/**
 * 获取股票的期权概况
 * @param {array} data.items 期权列表
 * @returns {PromiseLike<HttpResponse>}
 */
export function fetchOptionBriefs(data) {
  return Vue.http.post('~option/option/briefs', data)
}

/**
 * 获取单个期权摘要信息
 * @param { object } params
 * @returns {PromiseLike<HttpResponse>}
 */
export function fetchOptionBrief(params) {
  return Vue.http.get('~option/option/brief/{symbol}', { params })
}

/**
 * 获取单个期权逐笔列表
 * @param {object} params
 * @param {string} params.symbol 股票代码
 * @param {number} params.expiry 期权到期时间
 * @param {string} params.strike 行权价
 * @param {string} params.right 看多/看空
 * @param {number} params.endIndex 结束索引
 * @param {number} params.limit 数量
 * @returns {PromiseLike<HttpResponse>}
 */
export function fetchOptionTradeTick(params) {
  return Vue.http.get('~option/option/trade/{symbol}', { params })
}

/**
 * 批量获取期权详情
 * @param {array} data.items 期权列表
 * @returns {PromiseLike<HttpResponse>}
 */
export function fetchOptionDetails(data) {
  return Vue.http.post('~option/option/details', data)
}

/**
 * 获取指定股票的期权链
 * @param {string} symbol 股票代码
 * @returns {PromiseLike<HttpResponse>}
 */
export function fetchStockOptionChains(symbol) {
  return Vue.http.get(`~option/option/chain/${symbol}`)
}

/**
 * 获取指定过期时间的期权链
 * @param {string} params.symbol 股票代码
 * @param {number} params.expiry 过期时间
 * @returns {PromiseLike<HttpResponse>}
 */
export function fetchActualExpiryOptionChain(params) {
  return Vue.http.get('~option/option/ab/{symbol}', { params })
}

/**
 * 获取期权日 K 信息
 * @param {string} params.symbol 股票代码
 * @param {number} params.expiry 期权到期时间
 * @param {string} params.strike 行权价
 * @param {string} params.right 看多/看空
 * @param {number} params.beginTime 开始时间
 * @param {number} params.endTime 结束时间
 */
export function fetchOptionKLine(params) {
  return Vue.http.get('~option/option/kline/{symbol}', { params })
}
